module.exports = __webpack_public_path__ + "img/mtc-advanced-logo.47155b2e.png";